import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import axios from 'axios/index';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userName: "",
    email: ""
  },
  mutations: {
    setUserDetails(state, userinfo) {
      state.userName = userinfo.preferred_username;
      state.email = userinfo.email;
    state},
    clearUserDetails(state) {
      state.userName = "";
      state.email = "";
    }
  },
  actions: {
    async retrieveUserDetails(context) {
      if (process.env.NODE_ENV === 'development') {
        context.commit("setUserDetails", {"preferred_username": "DEVUSER", "email": "nobody@sodisce.si"})
      } else {
        await axios.get("/protected/redirect_uri?info=json")
          .then((res) => {
            context.commit("setUserDetails", res.data.userinfo);
          })
          .catch((error) => {
            /* eslint-disable no-console */
            console.error(error);
          });
        }
    },
  },
  modules: {
  },
  plugins: [createPersistedState()]
})
